"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbaToHsla = exports.rgbToHsl = void 0;
var tslib_1 = require("tslib");
var tinycolor_1 = require("@ctrl/tinycolor");
var number_to_hue_1 = require("../from-number/number-to-hue");
var number_to_percent_1 = require("../from-number/number-to-percent");
var rgbToHsl = function (_a) {
    var _b = tslib_1.__read(_a, 3), r = _b[0], g = _b[1], b = _b[2];
    var tc = new tinycolor_1.TinyColor({ r: r, g: g, b: b });
    var _c = tc.toHsl(), h = _c.h, s = _c.s, l = _c.l;
    return [(0, number_to_hue_1.numberToHue)(h), (0, number_to_percent_1.numberToPercent)(100 * s), (0, number_to_percent_1.numberToPercent)(100 * l)];
};
exports.rgbToHsl = rgbToHsl;
var rgbaToHsla = function (_a) {
    var _b = tslib_1.__read(_a, 4), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
    var _c = tslib_1.__read((0, exports.rgbToHsl)([r, g, b]), 3), h = _c[0], s = _c[1], l = _c[2];
    return [h, s, l, a];
};
exports.rgbaToHsla = rgbaToHsla;
